import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next'

/**
 * 入力フォームのエラー内容に応じて画面に表示する文を返す
 * @param error エラー情報
 * @param validateText エラータイプがvalidateだった場合に表示する文
 * @returns 画面に表示するエラー文
 */
export function ErrorIndicator(error: FieldError | undefined, validateText: string = ""): string{

    const [t] = useTranslation();

    let errorText = "";

    if(error !== undefined){
        switch(error.type){
            case "required":
                errorText = t("Errors.Required");
                break;
            case "pattern":
                errorText = t("Errors.Pattern");
                break;
            case "maxLength":
                errorText = t("Errors.MaxLength");
                break;
            case "matchMailAddress":
                errorText = t("Errors.MatchMailAddress")
                break;
            case "ageOver30":
                errorText = t("Errors.AgeOver30")
                break;
            case "invalidDate":
                errorText = t("Errors.InvalidDate")
                break;
            case "fileSize":
                errorText = t("Errors.FileSize")
                break;
            case "fileType":
                errorText = t("Errors.FileType")
                break;
            case "validate":
                errorText = validateText;
                break;
        }
    }

    return(errorText);

}